module.exports = __webpack_public_path__ + "media/images/emblems/Bullet-coat_of_arms-62047b4cc222de02e0c7edd9e23b18d7.svg";